import {
  LIST_SERVICE_GROUP_REQUEST,
  LIST_SERVICE_GROUP_SUCCESS,
  LIST_SERVICE_GROUP_FAIL,
  CREATE_SERVICE_GROUP_REQUEST,
  CREATE_SERVICE_GROUP_SUCCESS,
  CREATE_SERVICE_GROUP_FAIL,
  DETAIL_SERVICE_GROUP_SERVICE_REQUEST,
  DETAIL_SERVICE_GROUP_SERVICE_SUCCESS,
  DETAIL_SERVICE_GROUP_SERVICE_FAIL,
  DETAIL_SERVICE_GROUP_REQUEST,
  DETAIL_SERVICE_GROUP_SUCCESS,
  DETAIL_SERVICE_GROUP_FAIL,
  UPDATE_SERVICE_GROUP_REQUEST,
  UPDATE_SERVICE_GROUP_SUCCESS,
  UPDATE_SERVICE_GROUP_FAIL,
  UPDATE_SERVICE_GROUP_SERVICE_REQUEST,
  UPDATE_SERVICE_GROUP_SERVICE_SUCCESS,
  UPDATE_SERVICE_GROUP_SERVICE_FAIL,
  DELETE_SERVICE_GROUP_REQUEST,
  DELETE_SERVICE_GROUP_SUCCESS,
  DELETE_SERVICE_GROUP_FAIL,
  DELETE_SERVICE_GROUP_SERVICE_REQUEST,
  DELETE_SERVICE_GROUP_SERVICE_SUCCESS,
  DELETE_SERVICE_GROUP_SERVICE_FAIL,
  CREATE_SERVICE_GROUP_SERVICE_REQUEST,
  CREATE_SERVICE_GROUP_SERVICE_SUCCESS,
  CREATE_SERVICE_GROUP_SERVICE_FAIL,
  RESET_SERVICE_GROUP
} from '../../constants/service-groups'

const initialState = {
  loading: false,
  serviceGroups: [],
  serviceGroup: {},
  serviceGroupService: [],
  error: null,
  pageable: {}
}

const serviceGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_GROUP_REQUEST:
      return { ...state, loading: true }
    case LIST_SERVICE_GROUP_SUCCESS:
      return { ...state, loading: false, serviceGroups: action.payload, pageable: action.pageable }
    case LIST_SERVICE_GROUP_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_SERVICE_GROUP_SERVICE_REQUEST:
      return { ...state, loading: true }
    case DETAIL_SERVICE_GROUP_SERVICE_SUCCESS:
      return { ...state, loading: false, serviceGroupService: action.payload, pageable: action.pageable }
    case DETAIL_SERVICE_GROUP_SERVICE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_SERVICE_GROUP_REQUEST:
      return { ...state, loading: true }
    case CREATE_SERVICE_GROUP_SUCCESS:
      return { ...state, loading: false }
    case CREATE_SERVICE_GROUP_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_SERVICE_GROUP_SERVICE_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_SERVICE_GROUP_SERVICE_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_SERVICE_GROUP_SERVICE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_SERVICE_GROUP_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_SERVICE_GROUP_SUCCESS:
      return { ...state, loadingDetail: false, serviceGroup: action.payload }
    case DETAIL_SERVICE_GROUP_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_SERVICE_GROUP_REQUEST:
      return { ...state, loading: true }
    case UPDATE_SERVICE_GROUP_SUCCESS:
      return { ...state, loading: false }
    case UPDATE_SERVICE_GROUP_FAIL:
      return { ...state, loading: false, error: action.payload }
    case UPDATE_SERVICE_GROUP_SERVICE_REQUEST:
      return { ...state, loading: true }
    case UPDATE_SERVICE_GROUP_SERVICE_SUCCESS:
      return { ...state, loading: false }
    case UPDATE_SERVICE_GROUP_SERVICE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DELETE_SERVICE_GROUP_REQUEST:
      return { ...state, loading: true }
    case DELETE_SERVICE_GROUP_SUCCESS:
      return { ...state, loading: false }
    case DELETE_SERVICE_GROUP_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DELETE_SERVICE_GROUP_SERVICE_REQUEST: 
      return { ...state, loadingDelete: true }
    case DELETE_SERVICE_GROUP_SERVICE_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_SERVICE_GROUP_SERVICE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_SERVICE_GROUP:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default serviceGroupReducer